<div class="package-content">
  @for (group of benefitGroups; track group.benefitTypeId) {
    <div class="benefit-container">
      <div class="benefit-name mb-1">{{ group.benefitTypeName }}</div>
      <div
        class="benefit-level-control d-flex justify-content-between dropdown"
        [ngClass]="{ 'read-only': group.benefits.length <= 1 || isReadOnly }">
        <div class="control-content flex-fill">
          <div class="level-description mb-1">{{ group.selectedOption?.description }}</div>
          @if (group.selectedOption?.limitation) {
            <div class="level-limitation">{{ group.selectedOption?.limitation }}</div>
          }
        </div>
        @if (group.benefits.length > 1 && !isReadOnly) {
          <div
            class="action-container"
            [class.show]="openGroupId === group.benefitTypeId"
            (click)="toggleDropdown(group, $event)">
            <mat-icon class="collapse-icon">keyboard_arrow_up</mat-icon>
            <button
              class="edit-btn btn-sm"
              mat-icon-button
              color="primary"
              type="button"
              aria-label="Edit benefit level">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
          <div class="dropdown-menu dropdown-menu-end" [class.show]="openGroupId === group.benefitTypeId">
            <div class="levels-list">
              @for (benefit of group.benefits; track benefit.id) {
                <div
                  class="level-option"
                  [ngClass]="benefit.id === group.selectedOption?.id ? 'selected' : ''"
                  (click)="onOptionChange(group, benefit)">
                  <div class="d-flex align-items-center w-100">
                    <div class="icon-wrapper me-2 me-md-3">
                      @if (benefit.id === group.selectedOption?.id) {
                        <mat-icon>check</mat-icon>
                      }
                    </div>
                    <div class="d-flex flex-fill align-items-center justify-content-between flex-wrap">
                      <div>
                        <div class="level-description mb-1">{{ benefit.description }}</div>
                        @if (benefit.limitation) {
                          <div class="level-limitation">{{ benefit.limitation }}</div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
